import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const addReasonTodo = createAsyncThunk('addReason', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'reasons',
            data: {
                "reason_name": data.reason_name,
                "status": data.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') }
        })
        return res

    } catch (error) {
        return error?.response
    }
})


